import { axios, Response } from '../index'

const unbindTherapist = (
  patientId: string,
  therapistId: string
): Response<null> => {
  return axios.delete(
    `/v1/patients/${patientId}/therapists-responsible/${therapistId}`
  )
}

export default unbindTherapist
